export default function useFieldName(rawName?: string, rawFieldName?: string) {
  const name = rawName ? rawName : "";
  const fieldName = rawFieldName || name;

  return { name, fieldName };
}
